export const GRACE_PAWPPER = {
  USERNAME: 'grace.pawpper1906',
  FIRST_NAME: 'Grace',
  LAST_NAME: 'Pawpper',
  EMAIL: 'grace.pawpper@bitsburg.io',
} as const;

export const CREDIT_CARDS = {
  VISA_FULL: '4242424242424242',
  VISA_FORMATTED: '4242 4242 4242 4242',
  MASTERCARD_FULL: '5555555555554444',
  MASTERCARD_FORMATTED: '5555 5555 5555 4444',
} as const;
